<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div>
      <div id="track">
        <div class="d-flex justify-content-between">
          <div>
            <a href="/ExhibitorServiceTW/">展覽列表</a><span>/</span>
            <em name="Exhibition"></em><span>/</span>大會活動<span>/</span
            ><span class="px-0">{{ EventDetail.eventName }} </span>
          </div>
          <div>
            <span class="bold">登入帳號 :</span>
            <span> {{ UserId }}</span>
          </div>
        </div>
      </div>
      <!-- track end -->
      <!-- article -->
      <article>
        <div class="MbDevice">
          <div class="homeLeft">
            <div class="UserAccount ml-1">
              <span class="bold">登入帳號 :</span>
              <span> {{ UserId }}</span>
            </div>
            <hr />
            <div class="expoLogo"><img :src="ExhLogo" width="100%" /></div>
            <div class="expoInfo">
              <p class="bold" name="Exhibition"></p>
              <p>{{ ExhBegin }} - {{ ExhEnd }}</p>
              <p>{{ ExhVenue }}</p>
            </div>
            <p class="clear"></p>
          </div>
        </div>

        <div class="contentBox">
          <h1>{{ EventDetail.eventName }}</h1>

          <p class="formTitle mt-5">活動說明</p>
          <p class="mb-4 mt-1 event-desc" v-html="EventDetail.backEndDesc"></p>

          <p class="formTitle mt-3">開放時間</p>
          <p class="mb-4 mt-1">{{ OpendateString }} - {{ ClosedateString }}</p>

          <p class="formTitle mt-3" v-if="EventDetail.backEndNotice">
            注意事項
          </p>
          <p
            class="mb-4 mt-1"
            v-if="EventDetail.backEndNotice"
            v-html="EventDetail.backEndNotice"
          ></p>

          <div class="mt-5" v-if="ShowRegiter">
            <div class="d-flex align-items-center justify-content-start mb-4">
              <div v-if="isStart">
                <div v-if="booth_sqm >= minBoothQty">
                  <div v-if="maxProductQty <= RegisterListNum">
                    <div
                      class="btn btn-lg btn-primary text-nowrap disabled"
                      v-if="LocalExh"
                    >
                      已達報名上限
                    </div>
                    <div
                      class="btn btn-lg btn-primary text-nowrap disabled"
                      v-if="!LocalExh"
                    >
                      已達發布上限
                    </div>
                  </div>
                  <div v-else>
                    <div
                      class="btn btn-lg btn-primary text-nowrap"
                      @click.prevent="toProductSelect"
                      v-if="LocalExh"
                    >
                      我要報名
                    </div>

                    <div
                      class="btn btn-lg btn-primary text-nowrap"
                      @click.prevent="toProductSelect"
                      v-if="!LocalExh"
                    >
                      我要發布
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="btn btn-lg btn-primary text-nowrap disabled">
                    未達資格
                  </div>
                </div>
              </div>
              <div v-else-if="!isStart">
                <div class="btn btn-lg btn-primary text-nowrap disabled">
                  尚未開放
                </div>
              </div>
            </div>

            <div class="alert">
              <p>
                1. 參展攤位數需達
                <span class="red"> {{ minBoothQty }} </span>個以上
                ，才可參加本活動
              </p>
              <p>
                2. 您已經報名
                <span class="red">{{ RegisterListNum }}</span>
                個產品，還可以選擇
                <span class="red">{{ maxProductQty - RegisterListNum }}</span>
                個產品參加本活動
              </p>
            </div>

            <div
              v-if="RegisterListNum > 0"
              class="mt-4"
              style="font-size: 22px"
            >
              <div v-if="LocalExh">
                <i class="fas fa-chevron-circle-down text-warning"></i>
                已報名產品
              </div>

              <div v-else>
                <i class="fas fa-chevron-circle-down text-warning"></i>
                已發布產品
              </div>
            </div>

            <div class="row" v-if="booth_sqm >= minBoothQty">
              <div
                class="col-sm-3 mb-2"
                v-for="(item, index) in MarketingRegisterList"
                :key="index"
              >
                <div class="card mt-4">
                  <div class="card-body">
                    <div class="imgstyle text-center">
                      <img
                        :src="`//www.chanchao.com.tw/exhibitorServicefiles/products/${item.proImg}`"
                        class="img-fluid mt-2"
                        width="130px"
                      />
                    </div>
                    <ul class="list-group list-group-flush mx-2">
                      <div class="mt-3 mb-2 h5">
                        <strong>{{ item.proName }}</strong>
                      </div>

                      <p class="gray" v-if="LocalExh">
                        分類名稱：{{ item.mCatName }}
                      </p>
                      <div class="gray" v-if="!LocalExh">
                        <div v-if="item.mCatName">
                          分類名稱：{{ item.mCatName }}
                        </div>
                        <div v-if="item.emCatName">
                          分類名稱：{{ item.emCatName }}
                        </div>
                      </div>
                      <p class="gray" v-if="inputOnlineDateHidden == 0">
                        上市時間：{{ item.reg_LaunchDate }}
                      </p>
                      <p class="gray" v-if="inputPriceHidden == 0">
                        市價：{{ item.reg_Price }}
                      </p>
                      <p class="gray" v-if="inputDiscountPriceHidden == 0">
                        展場限定價：{{ item.reg_DiscountPrice }}
                      </p>
                      <p class="gray" v-if="inputDescHidden == 0 && LocalExh">
                        {{ inputDescName }}：{{ item.reg_Desc }}
                      </p>
                      <p class="gray" v-if="inputDescHidden == 0 && !LocalExh">
                        {{ einputDescName }}：{{ item.ereg_Desc }}
                      </p>
                      <p class="gray" v-if="inputDescHidden2 == 0 && LocalExh">
                        {{ inputDescName2 }}：{{ item.reg_Desc2 }}
                      </p>

                      <p class="gray" v-if="inputDescHidden2 == 0 && !LocalExh">
                        {{ einputDescName2 }}：{{ item.ereg_Desc2 }}
                      </p>

                      <div class="card-footer mt-3 bg-white">
                        <div
                          class="d-flex justify-content-center align-items-center mt-2"
                        >
                          <div
                            class="btn btn-primary py-2"
                            @click.prevent="EditPromotion(item.regId)"
                          >
                            編輯
                          </div>
                          <div
                            class="btn btn-secondary ml-3 py-2"
                            @click.prevent="DelPromotion(item.regId)"
                          >
                            取消
                          </div>
                        </div>
                      </div>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  metaInfo() {
    return {
      title: "產品推廣活動 - 展昭參展商管理系統",
    };
  },

  data() {
    return {
      UserId: "",
      RegNo: "",
      CSRF_Token: "",
      lang: "tw",
      EventDetail: {},
      MarketingRegisterList: [],
      eventId: "",
      booth_sqm: "",
      minBoothQty: "",
      maxProductQty: "",
      RegisterListNum: "",

      inputDescHidden: "",
      inputDescHidden2: "",
      inputDescName2: "",
      einputDescName2: "",
      einputDescName: "",
      inputOnlineDateHidden: "",
      inputPriceHidden: "",
      inputDiscountPriceHidden: "",
      ShowRegiter: false,

      OpendateString: "",
      ClosedateString: "",
      OpenSec: "",
      OpenMin: "",
      CloseSec: "",
      CloseMin: "",
      inputDescName: "",

      ExhLogo: "",
      ExhBegin: "",
      ExhEnd: "",
      ExhVenue: "",
      eExhVenue: "",
      LocalExh: true,

      isStart: true,
    };
  },

  watch: {},

  methods: {
    toProductSelect() {
      const vm = this;

      if (vm.booth_sqm >= vm.minBoothQty) {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotionSelectPro?no=${vm.RegNo}&eventId=${vm.eventId}`;
      } else {
        alert("您報名的實體攤位數需高於活動指定攤位數才可進行報名。");
      }
    },

    EditPromotion(id) {
      const vm = this;
      document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotionEdit?no=${vm.RegNo}&eventId=${vm.eventId}&regId=${id}`;
    },

    DelPromotion(id) {
      const vm = this;

      if (confirm("請確認要取消推廣此產品？")) {
        const info = {
          CSRF: vm.CSRF_Token,
        };

        const url = `/apiExhibitors/MarketingEventRegister/${vm.RegNo}/${id}`;

        axios.post(url, { CSRF: vm.CSRF_Token }).then(function (response) {
          // console.log(response.data)

          if (response.data.Code == 200) {
            document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
          } else if (response.data.Code == 253) {
            alert("報名序號錯誤或不存在！");
            document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
          } else if (response.data.Code == 252) {
            alert("CSRF驗證失敗！");
            document.location.href = `https://www.chanchao.com.tw/`;
          } else if (response.data.Code == 500) {
            alert("系統忙線中，請稍後再試！");
            document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
          }
        });
      } else {
        return false;
      }
    },
  },

  computed: {},

  created() {
    const vm = this;

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //url取出展碼
    let currentUrl = location.href;
    vm.eventId = currentUrl.split("eventId=")[1].split("&")[0];
    vm.RegNo = currentUrl.split("no=")[1];

    // console.log(vm.RegNo)

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${vm.lang}`,
      )
      .then((response) => {
        vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.ExhLogo}`;
        vm.ExhBegin = response.data.ExhBegin;
        vm.ExhEnd = response.data.ExhEnd;
        vm.ExhVenue = response.data.ExhVenue;
        vm.eExhVenue = response.data.eExhVenue;
        let ExpoLocation = response.data.Data.ExpoLocation;

        if (ExpoLocation === "T" || ExpoLocation === null) {
          vm.LocalExh = true;
        } else {
          vm.LocalExh = false;
        }
      });

    //取得活動總資料
    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/MarketingEvent?eventId=${vm.eventId}`,
      )
      .then((response) => {
        if (response.data.Code == 200) {
          vm.EventDetail = response.data.Data;
          vm.minBoothQty = response.data.Data.minBoothQty;
          vm.maxProductQty = response.data.Data.maxProductQty;

          vm.inputDescHidden = response.data.Data.inputDescHidden;
          vm.inputDescHidden2 = response.data.Data.inputDescHidden2;

          vm.inputOnlineDateHidden = response.data.Data.inputOnlineDateHidden;
          vm.inputPriceHidden = response.data.Data.inputPriceHidden;
          vm.inputDiscountPriceHidden =
            response.data.Data.inputDiscountPriceHidden;

          vm.inputDescName = response.data.Data.inputDescName;
          vm.inputDescName2 = response.data.Data.inputDescName2;

          vm.einputDescName = response.data.Data.einputDescName;
          vm.einputDescName2 = response.data.Data.einputDescName2;

          // vm.backEndStartDate = response.data.Data.backEndStartDate

          let OpenRegiterDate = response.data.Data.backEndStartDate;
          let CloseRegiterDate = response.data.Data.backEndEndDate;
          let Nowdate = Date.parse(new Date()).valueOf();

          //時間標記Timestamp轉日期(backEndStart)

          let Opentimestamp = Number(OpenRegiterDate);
          let Opendate = new Date(Opentimestamp);

          if (Opendate.getMinutes() == 0) {
            vm.OpenMin = "00";
          } else {
            vm.OpenMin = Opendate.getMinutes();
          }

          if (Opendate.getSeconds() == 0) {
            vm.OpenSec = "00";
          } else {
            vm.OpenSec = Opendate.getSeconds();
          }

          vm.OpendateString =
            Opendate.getFullYear() +
            "/" +
            (Opendate.getMonth() + 1) +
            "/" +
            Opendate.getDate() +
            " " +
            Opendate.getHours() +
            ":" +
            vm.OpenMin +
            ":" +
            vm.OpenSec;

          //時間標記Timestamp轉日期(backEndEndDate)

          let Closetimestamp = Number(CloseRegiterDate);
          let Closedate = new Date(Closetimestamp);

          if (Closedate.getMinutes() == 0) {
            vm.CloseMin = "00";
          } else {
            vm.CloseMin = Closedate.getMinutes();
          }

          if (Closedate.getSeconds() == 0) {
            vm.CloseSec = "00";
          } else {
            vm.CloseSec = Closedate.getSeconds();
          }

          vm.ClosedateString =
            Closedate.getFullYear() +
            "/" +
            (Closedate.getMonth() + 1) +
            "/" +
            Closedate.getDate() +
            " " +
            Closedate.getHours() +
            ":" +
            vm.CloseMin +
            ":" +
            vm.CloseSec;

          let archived = response.data.Data.archived;
          if (archived == 1) {
            vm.ShowRegiter = false;
          } else {
            vm.ShowRegiter = true;

            if (Nowdate < OpenRegiterDate) {
              vm.ShowRegiter = true;
              vm.isStart = false;
            } else if (
              Nowdate >= OpenRegiterDate &&
              Nowdate <= CloseRegiterDate
            ) {
              vm.ShowRegiter = true;
              vm.isStart = true;
            } else if (Nowdate > CloseRegiterDate) {
              vm.ShowRegiter = false;
              vm.isStart = true;
            }
          }

          axios
            .get(
              `https://www.chanchao.com.tw/apiExhibitors/MarketingEventRegister?regNo=${vm.RegNo}&eventId=${vm.eventId}`,
            )
            .then((response) => {
              vm.MarketingRegisterList = response.data.Data;

              if (response.data.datatotal) {
                vm.RegisterListNum = response.data.datatotal;
              } else {
                vm.RegisterListNum = 0;
              }
            });
        } else {
          let lastPage = document.referrer;

          if (lastPage) {
            document.location.href = `${lastPage}`;
          } else {
            document.location.href =
              "https://www.chanchao.com.tw/ExhibitorServiceTW/";
          }
        }
      });

    //實體攤位數
    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/Exhibitor/${vm.RegNo}`)
      .then((response) => {
        // console.log(response.data)
        vm.booth_sqm = response.data.Data.booth_sqm;
      });
  },
};
</script>

<style lang="scss">
.event-desc ol {
  margin-left: 20px; /* 控制外邊距 */
}
</style>
